import { call, put, select, takeLatest, all, delay } from 'redux-saga/effects';
import Action from '../action';
import InvoiceApi from '../../Api/inoviceApi';
import userApi from '../../Api/userApi';
// import { stream } from "xlsx/types";
import { MENU_INFO } from '../../../../Utils/enums';
import Func from '../../../../Utils/func';
import ObjectStorageUtil from '../../../../Utils/ObjecStorageUtil';
import CommonApi from '../../Api/commonApi';
import { REGEX_NUMBER } from '../../../../Utils/regexManager';
import taker from './taker';
import $ from 'jquery';
import companyApi from '../../Api/companyApi';
import CryptoJS from 'crypto-js';
import moment_tz from 'moment-timezone';

//로딩
export function* setProgressBar({ payload }) {
  yield put(Action.setProgressBar.success(payload));
}

export function* addProgressBar(name) {
  yield put(Action.addProgressBar.success(name));

  yield call(setProgressBar, { payload: { open: true } });
}

export function* removeProgressBar(name) {
  yield put(Action.removeProgressBar.success(name));

  const list = yield select((state) => state.reducer.progressBarList);

  if (list.length == 0) {
    yield call(setProgressBar, { payload: { open: false } });
  }
}

export function* setSnackBar({ payload }) {
  yield put(Action.setSnackBar.success(payload));
}

//스낵바 닫기/초기화
export function* closeSnackBar() {
  yield put(Action.closeSnackBar.success(true));
}

export function* setDialog({ payload }) {
  yield put(Action.setDialog.success(payload));
}

//페이지 이동
export function* movePage(param) {
  document.location.href = '/#/' + param.url;
}

// 좌측 LEFT메뉴 (상단헤더 동시적용)
export function* setMenuType({ payload }) {
  /**
   * 로그인 유/무 체크 로직
   */
  if (payload.auth) {
    if (!$.cookie('authorization')) {
      yield call(movePage, { url: 'account/signIn', login: false });
    } else {
      yield put(Action.setMenuType.success(payload.menuType));
    }
  } else {
    yield put(Action.setMenuType.success(payload.menuType));
  }
}

export function* errorPopup(error) {
  if (error.error.response == '') {
    yield call(setDialog, {
      payload: {
        open: true,
        message: [
          <div style={{ marginTop: '30px' }}>
            <button className='btn-close-x'></button>
            <p className='desc'>
              <b>Unable to connect to the network at this time.</b>
              <br />
              <b>Please try again later.</b>
            </p>
          </div>,
        ],
        closeLabel: 'confirm',
      },
    });
  }
}

/**
 * 공통코드 관련 사가
 */
export function* getCode({ payload }) {
  try {
    const response = yield call(CommonApi.getCode, payload);

    if (response.status === 200) {
      yield put(Action.getCode.success(response.data));
    } else {
      yield put(Action.getCode.failure());
    }
  } catch (e) {
    yield put(Action.getCode.failure());
  }
}

export function* initCheckElement({ payload }) {
  yield put(Action.initCheckElement.success());
}

/**
 * [공통] invoice 초기화
 */
export function* initInvoice() {
  yield put(Action.initInvoice.success());
}

/**
 * [공통] initState 초기화
 */
export function* initState(param) {
  yield put(Action.initState.success());
}

/**
 * [공통] invoice 상세조회
 * @param {*} payload
 */
export function* getInvoice(param) {
  let invoice;
  const response = yield call(InvoiceApi.getInvoice, param);
  if (response.status === 200) {
    invoice = response.data;
    yield put(Action.getInvoice.success(invoice));
  }
}

/**
 * [공통] invoiceTemp 상세조회
 * @param {*} payload
 */
export function* getInvoiceTemp(param) {
  let invoice;
  const response = yield call(InvoiceApi.getInvoiceTemp, param);
  if (response.status === 200) {
    invoice = response.data;
    yield put(Action.getInvoice.success(invoice));
  }
}

/**
 * [공통] invoice POS 상세조회
 * @param {*} payload
 */
export function* getInvoicePos(param) {
  let invoice;
  const response = yield call(InvoiceApi.getInvoicePos, param);
  if (response.status === 200) {
    invoice = response.data;
    yield put(Action.getInvoice.success(invoice));
  }
}

/**
 * [공통] invoice 리스트 조회
 * @param {*} param
 */
export function* getInvoiceList(param) {
  let invoiceList;
  const response = yield call(InvoiceApi.getInvoiceList, param);
  if (response.status === 200) {
    invoiceList = response.data;

    yield call(setInvoiceList, invoiceList);
  }
}

/**
 * [공통] invoice POS 리스트 조회
 * @param {*} param
 */
export function* getInvoicePosList(param) {
  let invoiceList;
  const response = yield call(InvoiceApi.getInvoicePosList, param);
  if (response.status === 200) {
    invoiceList = response.data;

    yield call(setInvoiceList, invoiceList);
  }
}

/**
 * [공통] setInvoiceList
 * @param {*} param
 */
export function* setInvoiceList(param) {
  //payload 있을경우 변환
  if (param.payload) {
    param = payload;
  }
  yield put(Action.setInvoiceList.success(param));
}

/**
 * [공통] invoiceList total amount 조회
 * @param {*} param
 */
export function* getInvoiceListTotalAmout(param) {
  let totalAmount;
  const response = yield call(InvoiceApi.getInvoiceListTotalAmount, param);
  if (response.status === 200) {
    totalAmount = response.data;
    yield put(Action.setInvoiceListTotalAmount.success(totalAmount));
  }
}

/**
 * [공통] invoicePos List total amount 조회
 * @param {*} param
 */
export function* getInvoicePosListTotalAmout(param) {
  let totalAmount;
  const response = yield call(InvoiceApi.getInvoicePosListTotalAmount, param);
  if (response.status === 200) {
    totalAmount = response.data;
    yield put(Action.setInvoiceListTotalAmount.success(totalAmount));
  }
}

/**
 * invoice Issue(copy, correction)시 detail 조회
 * @param {*} param
 */
export function* getIssueInvoiceDetail({ payload }) {
  let invoice;
  const response = yield call(
    InvoiceApi.getCopyCorrectionInvoiceDetail,
    payload
  );
  if (response.status === 200) {
    invoice = response.data;
    if (payload.type === 'copy') {
      yield put(Action.getInvoice.success(invoice));
    } else if (payload.type === 'correction') {
      yield put(Action.getInvoiceCorrectDetail.success(invoice));
    }

    // invoice 조회는 성공했지만, 존재하지 않는 데이터
    if (!invoice.uniqueInvoiceId) {
      if (payload.type === 'copy')
        Func.moveExUrl(MENU_INFO['issuance_3'].mainURL, null);
    }
  } else if (response.status === 203) {
    // 요청은 성공하였으나, 사용자 검증이 안됨
    if (payload.type === 'copy')
      Func.moveExUrl(MENU_INFO['issuance_3'].mainURL, null);
  }
}

/********************************************************************************/

/**
 * [ObjectStorage] ObjectStorage File Upload
 * @param {*} param
 */
export function* objectStorageUpload({ payload }) {
  yield all([
    ...payload.fileList.map((file) =>
      call(CommonApi.setObjectStorageUpload, {
        file: file,
      })
    ),
  ]);
}

/**
 * [ObjectStorage] ObjectStorage File Download
 * @param {*} param
 */
export function* objectStorageDownload({ payload }) {
  yield call(setProgressBar, { payload: { open: true } });

  const response = yield call(CommonApi.getObjectStorageDownloadUrl, payload);

  if (response.status === 200) {
    const res = yield call(ObjectStorageUtil.downloadFile, {
      url: response.data,
      fileOriginalName: payload.fileOriginalName,
    });

    if (res === 200) {
      yield call(setProgressBar, { payload: { open: false, message: '' } });
    } else {
      yield call(setProgressBar, { payload: { open: false, message: '' } });
      yield call(setDialog, {
        payload: {
          open: true,
          message: 'Failure File Download',
          closeLabel: 'confirm',
        },
      });
    }
  }
}

/**
 * [ObjectStorage] ObjectStorage File Delete
 * @param {*} param
 */
export function* objectStorageDelete({ payload }) {
  const response = yield call(CommonApi.setObjectStorageDelete, payload);

  if (response.status == 200) {
    yield call(setSnackBar, {
      payload: {
        autoHideDuration: 5000,
        message: 'File Delete Success!!',
        open: true,
        type: 'success',
      },
    });
  }
}

/**
 * [ObjectStorage] ObjectStorage AlwaysDownload Url (Viewer 전용)
 * @param {*} param
 */
export function* objectStorageAlwaysDownloadUrl({ payload }) {
  const response = yield call(
    CommonApi.getObjectStorageAlwaysDownloadUrl,
    payload
  );

  window.open(response.data, '_blank');
}

/**
 * [ObjectStorage] Template Download
 * @param {*} param0
 */
export function* templateDownload({ payload }) {
  const response = yield call(CommonApi.getTemplateDownload, payload);

  window.open(response.data, '_self');
}

/********************************************************************************/
export function* insertUser({ payload }) {
  // 주소 합치기
  const user = { ...payload.user };
  const company = { ...payload.company };
  delete user.confirmPassword;

  // tin 번호 합치기
  const companyTin = company.tin.join('');
  company.tin = companyTin;
  const userTin = user.userTin.join('');
  user.userTin = userTin;

  // confirmPassword 번호 합치기
  let cmpContactNumber = company.contactNumber.join('-');

  if (cmpContactNumber === '--') {
    cmpContactNumber = '';
  } else if (cmpContactNumber.charAt(cmpContactNumber.length - 1) === '-') {
    cmpContactNumber = cmpContactNumber.slice(0, -2);
  }

  company.contactNo = cmpContactNumber;
  delete company.contactNumber;

  let userContactNumber = user.contactNumber.join('-');
  if (userContactNumber === '--') {
    userContactNumber = '';
  } else if (userContactNumber.charAt(userContactNumber.length - 1) === '-') {
    userContactNumber = userContactNumber.slice(0, -2);
  }
  user.contactNo = userContactNumber;
  delete user.contactNumber;

  // Branch Code
  const companyBranchCode = company.branchCode.replace(REGEX_NUMBER, '');
  company.branchCode = companyBranchCode;
  if (companyBranchCode.length === 0) {
    company.branchCode = '00000';
  }
  const userBranchCode = user.userBranchCode.replace(REGEX_NUMBER, '');
  user.userBranchCode = userBranchCode;
  if (userBranchCode.length === 0) {
    user.userBranchCode = '00000';
  }

  const data = {
    userDto: user,
    companyDto: company,
  };

  // data -> EmployeeDto
  const employeeDto = {
    ...data,
  };

  // user TIN(Branch Code 포함) & email 중복 체크
  const checkResponse = yield call(userApi.existUserTinAndEmail, {
    tin: employeeDto.userDto.userTin,
    branchCode: employeeDto.userDto.userBranchCode,
    email: employeeDto.userDto.email,
    portalId: employeeDto.userDto.portalId,
  });
  if (checkResponse.status !== 200) {
    return yield call(setDialog, {
      payload: {
        open: true,
        message: 'User TIN & Email already exists.',
        closeLabel: 'confirm',
      },
    });
  }

  // 회원가입
  const response = yield call(userApi.insertUser, employeeDto);
  if (response.status === 200) {
    yield call(setDialog, {
      payload: {
        open: true,
        title: 'Success',
        message: [
          'Record accepted. BIR will be processing your enrollment.',
          'Please wait for email notification of status.',
        ],
        closeLabel: 'confirm',
        onClose: () => {
          window.location.href = '/#/account/signUp/success';
        },
      },
    });
  } else if (response.status !== 500) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: response.data.errorMessage,
        closeLabel: 'confirm',
      },
    });
  } else {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Internal Server Error.',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* isTin({ payload }) {
  const response = yield call(companyApi.isTin, payload);

  if (response.status == 200) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Success',
        closeLabel: 'confirm',
      },
    });

    yield put(Action.isTin.success());
  } else if (response.status == 210) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Invalid TIN & Branch Code',
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 409) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'TIN and Branch Code already exist',
        closeLabel: 'confirm',
      },
    });
    yield put(Action.isTin.failure());
  } else {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Server Internal Error',
        closeLabel: 'confirm',
      },
    });
    yield put(Action.isTin.failure());
  }
}

export function* existId({ payload }) {
  const response = yield call(userApi.existId, payload);
  if (response.status == 200) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Success',
        closeLabel: 'confirm',
      },
    });

    yield put(Action.existId.success(payload.portalId));
  } else {
    yield put(Action.existId.failure(payload.portalId));
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Already Exists User Name.',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* signIn({ payload }) {
  const response = yield call(userApi.signIn, payload.user);
  if (response.status == 200) {
    if (response.data.userAuthStatusCode.code == '02') {
  

      let serverTime = response.headers.server_time;

      const diffTime = moment_tz
        .duration(moment_tz().diff(moment_tz(serverTime)))
        .asSeconds();

      localStorage.setItem('diff-time', diffTime);

      // const getServerTime = response.headers.Date
      const date = new Date();
      // date.setTime(new Date().getTime() + 60 * 60 * 8 * 1000);
      date.setTime(new Date().getTime() + 8 * 60 * 60 * 1000);

      const cookieOption = {
        expires: date,
      };

      $.cookie('authorization', response.headers.auth_token, cookieOption);

      var company = {
        tin: response.data.employeeDtoList[0].companyDto.tin,
        branchCode: response.data.employeeDtoList[0].companyDto.branchCode,
        companyNo: response.data.employeeDtoList[0].companyDto.companyNo,
      };

      var user = {
        portalId: response.data.portalId,
        userNo: response.data.userNo,
        userTin: response.data.userTin,
      };

      const cryptoUser = CryptoJS.AES.encrypt(
        JSON.stringify(user),
        response.headers.auth_token
      ).toString();
      const cryptoCompany = CryptoJS.AES.encrypt(
        JSON.stringify(company),
        response.headers.auth_token
      ).toString();

      $.cookie('m_u', cryptoUser, cookieOption);
      $.cookie('m_c', cryptoCompany, cookieOption);

      if (!payload.path.state?.from) {
        yield call(movePage, { url: '', login: false });
      } else {
        yield call(movePage, { url: payload.path.state.from, login: false });
      }
    }

    yield put(Action.signIn.success(response));
  } else {
    yield put(Action.signIn.failure(response));
  }
}

export function* signOut() {
  const response = yield call(userApi.signOut, {});
  var cookies = $.cookie();
  for (var cookie in cookies) {
    $.removeCookie(cookie);
  }

  sessionStorage.clear();
  localStorage.clear();

  if (response.status == 200) {
    yield put(Action.signOut.success(response));
    yield call(movePage, { url: '', login: false });
  }
}

export function* searchId({ payload }) {
  const header = {
    authNumber: payload.authNumber,
  };

  const tin = payload.inquiry.userTin;
  const regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식
  const result = tin.replace(regex, ''); // 원래 문자열에서 숫자가 아닌 모든 문자열을 빈 문자로 변경
  const params = {
    ...payload.inquiry,
    userTin: result,
  };

  const response = yield call(userApi.searchId, params, header);
  if (response.status == 200) {
    yield put(Action.searchId.success(response));
    yield call(movePage, { url: 'account/find/id', login: false });
  } else if (response.status === 403) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'The authentication number does not match.',
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 404) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'No matching account.',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* sendSearchIdMail({ payload }) {
  const tin = payload.userTin;
  const regex = /[^0-9]/g; // 숫자가 아닌 문자열을 선택하는 정규식
  const result = tin.replace(regex, ''); // 원래 문자열에서 숫자가 아닌 모든 문자열을 빈 문자로 변경
  const params = {
    ...payload,
    userTin: result,
  };

  const response = yield call(userApi.sendMailSearchId, params);
  if (response.status === 200) {
    yield put(Action.sendSearchPwMail.success(response)); //인증번호 공통 Flag
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Successfully sent.',
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 404) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'No matching account.',
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 500) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Failed to send mail.',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* searchPw({ payload }) {
  const header = {
    authNumber: payload.authNumber,
  };
  const response = yield call(userApi.searchPw, payload.inquiry, header);
  if (response.status == 200) {
    yield put(Action.searchPw.success(response));
    yield call(movePage, { url: 'account/change/pw', login: false });
  } else if (response.status === 403) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'The authentication number does not match.',
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 404) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: response.data.errorMessage,
        closeLabel: 'confirm',
      },
    });
  }
}

export function* sendSearchPwMail({ payload }) {
  const response = yield call(userApi.sendSearchPwMail, payload);
  if (response.status === 200) {
    //인증번호 Flag
    yield put(Action.sendSearchPwMail.success(response));

    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Successfully sent.',
        closeLabel: 'confirm',
      },
    });
  }
  // TODO: 이 부분 401 임시 처리함(확인필요)
  // User Name 또는 Email 틀릴시 401 전송
  else if (response.status === 401) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'No matching User Name Or E-mail.',
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 404) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: response.data.errorMessage,
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 500) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Failed to send mail.',
        closeLabel: 'confirm',
      },
    });
  }
}

/**
 * 비밀번호 변경
 * @param {*} param0
 */
export function* changePassword({ payload }) {
  const checkPayload = {
    ...payload,
    password: payload.currentPassword,
  };

  // 비밀번호 확인 API
  const checkResponse = yield call(
    userApi.findByPortalIdAndPassword,
    checkPayload
  );

  if (checkResponse.status === 200) {
  } else if (checkResponse.status === 404) {
    yield put(Action.changePassword.failure(404));

    return yield call(setDialog, {
      payload: {
        open: true,
        message: 'Not Match Password.',
        closeLabel: 'confirm',
      },
    });
  } else {
    return yield call(setDialog, {
      payload: {
        open: true,
        message: 'Server Error.',
        closeLabel: 'confirm',
      },
    });
  }

  // 비밀번호 변경 API
  const requestPayload = {
    ...checkResponse.data,
    password: checkPayload.newPassword,
  };
  const response = yield call(userApi.changePassword, requestPayload);
  yield call(setProgressBar, { payload: { open: false } });

  if (response.status === 200) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Successfully changed.',
        closeLabel: 'confirm',
        onClose: () => {
          window.location.href = '/#';
        },
      },
    });

    yield put(Action.changePassword.success());
  } else if (response.status === 401) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: [
          'The server is disconnected.',
          'Please try again after re-logging.',
        ],
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 404) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Failed Change Password.',
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 409) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'It matches the previous passwords.',
        closeLabel: 'confirm',
      },
    });
  } else {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Internal Server Error',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* changePasswordByDialog({ payload }) {
  const checkPayload = {
    ...payload.form,
    password: payload.form.currentPassword,
  };

  // 비밀번호 확인 API
  const checkResponse = yield call(
    userApi.findByPortalIdAndPassword,
    checkPayload
  );

  if (checkResponse.status === 200) {
  } else if (checkResponse.status === 404) {
    yield put(Action.changePassword.failure());
    return payload.openDialog({
      message: 'Not Match Password.',
    });
  } else {
    yield put(Action.changePassword.failure());
    return payload.openDialog({
      message: 'Internal Server Error',
    });
  }

  // 비밀번호 변경 API
  const requestPayload = {
    ...checkResponse.data,
    password: checkPayload.newPassword,
  };
  const response = yield call(userApi.changePassword, requestPayload);
  if (response.status === 200) {
    yield put(Action.changePassword.success());
    return payload.openDialog({
      message: 'Successfully changed.',
    });
  } else if (response.status === 401) {
    yield put(Action.changePassword.failure());
    return payload.openDialog({
      message: 'The server is disconnected. Please try again after re-logging.',
    });
  } else if (response.status === 404) {
    yield put(Action.changePassword.failure());
    return payload.openDialog({
      message: 'Failed Change Password.',
    });
  } else if (response.status === 409) {
    yield put(Action.changePassword.failure());
    return payload.openDialog({
      message: 'It matches the previous passwords.',
    });
  } else {
    yield put(Action.changePassword.failure());
    return payload.openDialog({
      message: 'Internal Server Error',
    });
  }
}

/**
 * 비밀번호 초기화
 * @param {*} param0
 */
export function* resetPassword({ payload }) {
  yield call(setProgressBar, { payload: { open: true } });
  const response = yield call(userApi.resetPassword, payload);
  yield call(setProgressBar, { payload: { open: false } });

  if (response.status == 200) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Successfully changed password.',
        closeLabel: 'confirm',
        onClose: () => {
          window.location.href = '/#/account/signIn';
        },
      },
    });
    yield call(initUser);
    // yield call(movePage, 'account/signIn');
  } else if (response.status === 400) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: response.data.errorMessage,
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 404) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Failed Change Password.',
        closeLabel: 'confirm',
      },
    });
  } else if (response.status == 409) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'It matches the previous passwords.',
        closeLabel: 'confirm',
      },
    });
  } else {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Failed Change Password.',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* initCompany() {
  yield put(Action.initUser.success);
}

export function* initUser() {
  yield put(Action.initUser.success());
}

export function* getUser({ payload }) {
  const response = yield call(userApi.getUser, payload);
  if (response.status === 200) {
    return yield put(Action.getUser.success(response));
  } else if (response.status === 403) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: "It's a wrong access.",
        closeLabel: 'confirm',
        onClose: () => {
          window.location.href = '/#';
        },
      },
    });
  } else {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'External Server Error.',
        closeLabel: 'confirm',
      },
    });
  }

  return yield put(Action.getUser.success(response));
}

export function* updateUser({ payload }) {
  yield call(setProgressBar, { payload: { open: true } });
  // user TIN & email 중복 체크
  const checkResponse = yield call(userApi.existUserTinAndEmail, {
    portalId: payload.portalId,
    tin: payload.userTin,
    email: payload.email,
    branchCode: payload.userBranchCode,
  });
  if (checkResponse.status !== 200) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'User TIN & Email already exists.',
        closeLabel: 'confirm',
      },
    });

    yield call(setProgressBar, { payload: { open: false } });
    return;
  }

  const response = yield call(userApi.updateUser, payload);

  yield call(setProgressBar, { payload: { open: false } });
  if (response.status === 200) {
    yield put(Action.getUser.success(response));
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Success',
        closeLabel: 'confirm',
        onClose: () => {
          payload.onSuccess();
        },
      },
    });
  } else {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Failure Save',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* getCompany({ payload }) {
  const response = yield call(companyApi.getCompany, payload);

  if (response.status === 200) {
    yield put(Action.getCompany.success(response));
  } else {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Failure Company Call',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* setIssueInfo({ payload }) {
  yield all([getCompany({ payload }), getCode({ payload })]);
}

export function* updateCompany({ payload }) {
  const checkResponse = yield call(companyApi.isTin, {
    tin: payload.tin,
    branchCode: payload.branchCode,
    companyNo: payload.companyNo,
  });
  if (checkResponse.status !== 200) {
    return yield call(setDialog, {
      payload: {
        open: true,
        message: 'already TIN is exist.',
        closeLabel: 'confirm',
      },
    });
  }

  payload = {
    ...payload,
    companyRequest: 'UPDATE_INFO',
  };

  const response = yield call(companyApi.updateCompany, payload);
  if (response.status === 200) {
    yield call(getCompany, { payload: { companyNo: payload.companyNo } });
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Success',
        closeLabel: 'confirm',
        onClose: () => {
          payload.onSuccess();
        },
      },
    });
  }
}

export function* updateInvoiceSetting({ payload }) {
  yield call(setProgressBar, { payload: { open: true } });

  payload = {
    ...payload,
    companyRequest: 'UPDATE_INVOICE_SETTING',
  };
  const response = yield call(companyApi.updateCompany, payload);
  yield call(setProgressBar, { payload: { open: false } });

  if (response.status === 200) {
    yield put(Action.updateInvoiceSetting.success({ data: payload }));
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Success',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* deleteEmployee({ payload }) {
  const response = yield call(companyApi.deleteEmployee, payload);

  if (response.status === 200) {
    yield call(getCompany, { payload: { companyNo: payload.companyNo } });

    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Successfully removed',
        closeLabel: 'confirm',
      },
    });
  } else if (response.status === 400) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'There must be at least one active authorized person',
        closeLabel: 'confirm',
      },
    });
  }
}

export function* inviteEmployee({ payload }) {
  const response = yield call(companyApi.inviteEmployee, payload);

  if (response.status === 200) {
    payload.onSuccess();
  } else if (response.status === 409) {
    payload.onConflict();
  } else if (response.status === 400) {
    payload.onBadParams();
  }
}

export function* searchUserList({ payload }) {
  const response = yield call(userApi.searchUserList, payload);
  yield put(Action.searchUserList.success({ data: response }));
}

export function* changeUserStatus({ payload }) {
  const response = yield call(userApi.changeUserStatus, payload);
  yield put(Action.searchUserList.success({ data: response }));
}

export function* findByAuthorization({ payload }) {
  const response = yield call(userApi.findByAuthorization, payload);

  if (response.status === 200) {
    const cookieOption = {
      expires: new Date().setTime(new Date().getTime() + 60 * 60 * 8 * 1000),
    };

    var company = {
      tin: response.data.employeeDtoList[0].companyDto.tin,
      branchCode: response.data.employeeDtoList[0].companyDto.branchCode,
      companyNo: response.data.employeeDtoList[0].companyDto.companyNo,
    };

    var user = {
      portalId: response.data.portalId,
      userNo: response.data.userNo,
      userTin: response.data.userTin,
    };

    const cryptoUser = CryptoJS.AES.encrypt(
      JSON.stringify(user),
      $.cookie('authorization')
    ).toString();
    const cryptoCompany = CryptoJS.AES.encrypt(
      JSON.stringify(company),
      $.cookie('authorization')
    ).toString();

    if (!$.cookie('m_u')) {
      $.cookie('m_u', cryptoUser, cookieOption);
    }
    if (!$.cookie('m_c')) {
      $.cookie('m_c', cryptoCompany, cookieOption);
    }

    yield put(Action.findByAuthorization.success({ data: response.data }));
  } else {
    yield put(Action.findByAuthorization.failure({ data: response.data }));
  }
}

export function* getCompanyByTinAndBranchCode({ payload }) {
  const response = yield call(companyApi.getCompanyByTinAndBranchCode, payload);
  if (response.status !== 200) {
    yield call(setDialog, {
      payload: {
        open: true,
        message: 'Invalid Access Information',
        closeLabel: 'confirm',
      },
    });
  } else {
    yield put(Action.getCompany.success(response));
  }
}

export function* getTaxpayerDetail({ payload }) {
  const response = yield call(companyApi.getTaxpayerDetail, payload);

  if (response.status === 200) {
    yield put(Action.getTaxpayerDetail.success(response.data));
  }
}

export default [
  takeLatest(Action.setProgressBar.TRIGGER, setProgressBar),
  takeLatest(Action.addProgressBar.TRIGGER, addProgressBar),
  takeLatest(Action.removeProgressBar.TRIGGER, removeProgressBar),

  takeLatest(Action.setSnackBar.TRIGGER, setSnackBar),
  takeLatest(Action.closeSnackBar.TRIGGER, closeSnackBar),
  takeLatest(Action.setDialog.TRIGGER, setDialog),
  takeLatest(Action.setMenuType.TRIGGER, setMenuType),
  takeLatest(Action.errorPopup.TRIGGER, errorPopup),

  takeLatest(Action.initCheckElement.TRIGGER, initCheckElement),

  takeLatest(Action.setIssueInfo.TRIGGER, taker(setIssueInfo)),
  takeLatest(Action.getInvoice.TRIGGER, taker(getInvoice)),
  takeLatest(Action.getInvoiceList.TRIGGER, taker(getInvoiceList)),
  takeLatest(Action.setInvoiceList.TRIGGER, taker(setInvoiceList)),
  takeLatest(
    Action.getIssueInvoiceDetail.TRIGGER,
    taker(getIssueInvoiceDetail)
  ),

  takeLatest(Action.objectStorageUpload.TRIGGER, taker(objectStorageUpload)),
  // 파일다운로드로 인한 ProgressBar 따로 처리 위해 taker 제거
  takeLatest(Action.objectStorageDownload.TRIGGER, objectStorageDownload),
  takeLatest(Action.objectStorageDelete.TRIGGER, taker(objectStorageDelete)),
  takeLatest(
    Action.objectStorageAlwaysDownloadUrl.TRIGGER,
    taker(objectStorageAlwaysDownloadUrl)
  ),
  takeLatest(Action.templateDownload.TRIGGER, taker(templateDownload)),

  takeLatest(Action.setProgressBar.TRIGGER, setProgressBar),
  takeLatest(Action.setSnackBar.TRIGGER, setSnackBar),
  takeLatest(Action.closeSnackBar.TRIGGER, closeSnackBar),

  takeLatest(Action.getCode.TRIGGER, taker(getCode)),

  takeLatest(Action.insertUser.TRIGGER, taker(insertUser)),
  takeLatest(Action.isTin.TRIGGER, taker(isTin)),
  takeLatest(Action.existId.TRIGGER, taker(existId)),

  takeLatest(Action.signIn.TRIGGER, taker(signIn)),
  takeLatest(Action.signOut.TRIGGER, taker(signOut)),

  takeLatest(Action.searchId.TRIGGER, taker(searchId)),
  takeLatest(Action.sendSearchIdMail.TRIGGER, taker(sendSearchIdMail)),
  takeLatest(Action.searchPw.TRIGGER, taker(searchPw)),
  takeLatest(Action.sendSearchPwMail.TRIGGER, taker(sendSearchPwMail)),

  takeLatest(Action.changePassword.TRIGGER, taker(changePassword)),
  takeLatest(
    Action.changePasswordByDialog.TRIGGER,
    taker(changePasswordByDialog)
  ),
  takeLatest(Action.resetPassword.TRIGGER, taker(resetPassword)),
  takeLatest(Action.initUser.TRIGGER, taker(initUser)),

  takeLatest(Action.getUser.TRIGGER, taker(getUser)),
  takeLatest(Action.updateUser.TRIGGER, taker(updateUser)),

  takeLatest(Action.initCompany.TRIGGER, taker(initCompany)),
  takeLatest(Action.getCompany.TRIGGER, taker(getCompany)),
  takeLatest(
    Action.getCompanyByTinAndBranchCode.TRIGGER,
    taker(getCompanyByTinAndBranchCode)
  ),
  takeLatest(Action.updateCompany.TRIGGER, taker(updateCompany)),
  takeLatest(Action.updateInvoiceSetting.TRIGGER, updateInvoiceSetting),

  takeLatest(Action.deleteEmployee.TRIGGER, taker(deleteEmployee)),
  takeLatest(Action.inviteEmployee.TRIGGER, taker(inviteEmployee)),

  takeLatest(Action.searchUserList.TRIGGER, taker(searchUserList)),
  takeLatest(Action.changeUserStatus.TRIGGER, taker(changeUserStatus)),
  takeLatest(Action.findByAuthorization.TRIGGER, taker(findByAuthorization)),

  takeLatest(Action.getTaxpayerDetail.TRIGGER, taker(getTaxpayerDetail)),
];
